// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__PCrTY","tab":"Tabs_tab__WwBcu","tabActive":"Tabs_tabActive__2fOSi"};